/**
 * @name:上传
 * @description:图片视频混合上传到华为云
 * @author: huizi(huizi.li@shengyc.com)
 * @LastEditTime: 2020-04-02 13:39:20
 */
import { postHuaWeiOBS, get_file_upload_params } from '@/service/getData';
import axios from 'axios';
import { retrunMedia, getRandomCode } from './Utils';
/**
 * start 文件上传
 */
export async function _handleMedia(imgArry, videoArray) {
  let files = [];
  //   let newImgArr =
  //     imgArry.length > 0 &&
  //     imgArry
  //       .map((img, index) => {
  //         if (img.uri.indexOf('http') == -1) {
  //           return img;
  //         }
  //       })
  //       .filter(d => d);
  //   let newVideoArr =
  //     videoArray.length > 0 &&
  //     videoArray
  //       .map((video, index) => {
  //         if (video.uri.indexOf('http') == -1) {
  //           return video;
  //         }
  //       })
  //       .filter(d => d);
  if (imgArry.length > 0) {
    let originImages = imgArry.filter(v => v.modity);
    let newImages = imgArry.filter(v => !v.modity);
    await PromiseForEach(newImages).then(res => {
      let imgs = res.image.map(v => {
        let ary = v.split('/');
        return { name: ary[ary.length - 1], url: v };
      });
      files = originImages.concat(imgs);
    });
  }
  if (videoArray.length > 0) {
    await _uploadFile(videoArray[0]).then(res => {
      let ary = res.split('/');
      files.push({
        name: ary[ary.length - 1],
        url: res
      });
    });
  }
  return new Promise(resolve => {
    return resolve(files);
  });
}
function PromiseForEach(arr) {
  let realResult = { image: [] };
  let result = Promise.resolve();
  arr.forEach((a, index) => {
    result = result.then(() => {
      return _uploadFile(a).then(res => {
        realResult.image.push(res);
      });
    });
  });
  return result.then(() => {
    return realResult;
  });
}
/**
 * 文件上传到华为云
 */
async function _uploadFile(fileData) {
  let type = fileData.name;
  let key =
    getRandomCode(12) +
    encodeURI('scan.' + type.substring(type.lastIndexOf('.') + 1, type.length));
  let dataParams = new FormData();
  // let domain = 'http://slms.shengyc.com'; //:TODO暂时这样做，后续需要优化
  let domain = `http://${document.domain}`;
  let params = {}; // 华为云配置参数
  let res = await get_file_upload_params({
    key: key,
    type: type.substring(type.lastIndexOf('.') + 1, type.length)
  });
  params = res.type === 'tc_cos' ? res.tencent_params : res.params;
  // return params.url;
  if (res.type === 'tc_cos') {
    dataParams.append('policy', params.policy);
    dataParams.append('q-sign-algorithm', params.qSignAlgorithm);
    dataParams.append('q-ak', params.qAk);
    dataParams.append('q-key-time', params.qKeyTime);
    dataParams.append('key', params.key);
    dataParams.append('q-signature', params.qSignature);
    dataParams.append('file', fileData.file);
    // // 上传文件到腾讯云
    await axios
      .post(params.url, dataParams, {
        headers: {
          content_type: params.contentType
        }
      })
      .catch(err => {
        console.log('tencenterr', err);
      });
  } else {
    dataParams.append('policy', params.policy);
    dataParams.append('AccessKeyId', params.access_key_id);
    dataParams.append('signature', params.signature);
    dataParams.append('key', params.key);
    params.content_type
      ? dataParams.append('Content-Type', params.content_type)
      : '';
    dataParams.append('file', fileData.file);
    dataParams.option = {
      header: {
        Authorization: params.header_authorization,
        Origin: params.url
      }
    };
    //上传文件到华为云
    await axios.post(params.url, dataParams).catch(err => {
      console.log('9999', err);
    });

    // return axios.post(params.url, dataParams).then(res => {
    //   return params.file_url;
    // });
  }
  return res.type === 'tc_cos' ? params.fileUrl : params.file_url;
}
